const overflowWrap = {
  name: "overflow-wrap",
  path: "/overflow-wrap",
  title: "overflow-wrap",
  description: "Utilities for controlling how words should break when they exceed the width of their container.",
  value: {
    "overflow-wrap": {
      "wrap-break-word": "break-word",
      "wrap-normal": "normal",
      "wrap-anywhere": "anywhere"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="wrap-break-word w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
<p class="wrap-anywhere w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
<p class="wrap-normal w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">wrap-break-word</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">wrap-normal</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">wrap-anywhere</code> to control word breaking when content overflows.
      </p>
      <div class="space-y-6 max-w-xs">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">wrap-break-word</small>
          <p class="wrap-break-word w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">wrap-anywhere</small>
          <p class="wrap-anywhere w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">wrap-normal</small>
          <p class="wrap-normal w-48 border border-color-gray-200 p-4">Supercalifragilisticexpialidociousisaverylongwordthatmightoverflow.</p>
        </div>
      </div>
      `
    }
  ]
};

export default overflowWrap;
<div className="wrap-break-word wrap-normal wrap-anywhere sr-only"></div>